module.exports = require('vue');
